import { useReveal } from "@/hooks/useReveal";
import { Award, Camera, TrendingUp, Sparkles } from "lucide-react";

const credentials = [
    { icon: Award, text: "Consultora de imagen certificada" },
    { icon: Camera, text: "Experiencia en pasarela (6 años)" },
    { icon: TrendingUp, text: "Casos reales con resultados comprobables" },
    { icon: Sparkles, text: "Styling para empresarios, influencers y proyectos creativos" },
];

const cases = [
    {
        name: "Margarita Carrillo",
        role: "Madre y Empresaria",
        image: "https://customer-assets.emergentagent.com/job_hewser-minimal/artifacts/wv90sdyf_Margarita.png",
    },
    {
        name: "Roberto Becerra",
        role: "CEO Hewser, escritor, creador de contenido",
        image: "https://customer-assets.emergentagent.com/job_hewser-minimal/artifacts/3kl8r0jy_Roberto.webp",
    },
    {
        name: "Georgina Becerra",
        role: "Co Ceo Hewser web",
        image: "https://customer-assets.emergentagent.com/job_hewser-minimal/artifacts/hb3sj2yj_Georgina.webp",
    },
    {
        name: "Hotel Boutique",
        role: "Diseño de look para modelos profesionales para campaña Hotel Boutique",
        image: "https://customer-assets.emergentagent.com/job_hewser-minimal/artifacts/5q5rooqc_ilorojo.webp",
    },
    {
        name: "Video Musical",
        role: "Identidad y looks para un video musical",
        image: "https://customer-assets.emergentagent.com/job_hewser-minimal/artifacts/p385j9y4_ilorojo-2.webp",
    },
];

export default function Autoridad() {
    const { ref, visible } = useReveal();

    return (
        <section
            id="autoridad"
            data-testid="autoridad-section"
            className="relative py-24 md:py-36 bg-[#F7F3EE]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start mb-20 md:mb-28">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="section-number">Autoridad</span>
                            <span className="h-px w-12 bg-[#8C7C72]" />
                        </div>
                        <h2
                            data-testid="autoridad-title"
                            className="font-display text-[44px] md:text-[64px] leading-[1.05] text-[#1E1E1E] tracking-[-0.02em]"
                        >
                            Trayectoria que{" "}
                            <span className="font-italic-display text-[#C6A76A]">respalda</span>{" "}
                            cada propuesta.
                        </h2>
                    </div>

                    <div
                        ref={ref}
                        className={`lg:col-span-7 reveal ${visible ? "is-visible" : ""}`}
                    >
                        <div className="grid sm:grid-cols-2 gap-x-10 gap-y-10">
                            {credentials.map((c, i) => {
                                const Icon = c.icon;
                                return (
                                    <div
                                        key={c.text}
                                        data-testid={`autoridad-credential-${i}`}
                                        className="group"
                                    >
                                        <div className="flex items-center gap-3 mb-3">
                                            <Icon size={18} strokeWidth={1.25} className="text-[#C6A76A]" />
                                            <span className="text-[11px] tracking-[0.28em] uppercase text-[#8C7C72]">
                                                Credencial 0{i + 1}
                                            </span>
                                        </div>
                                        <p className="font-display text-xl md:text-2xl text-[#1E1E1E] leading-snug">
                                            {c.text}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Cases editorial grid */}
                <div className="mt-8">
                    <div className="flex items-baseline justify-between mb-10">
                        <h3
                            data-testid="autoridad-cases-title"
                            className="font-display italic text-[#1E1E1E] text-3xl md:text-5xl"
                        >
                            Casos
                        </h3>
                        <span className="text-[11px] tracking-[0.28em] uppercase text-[#8C7C72]">
                            Real Styling
                        </span>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6">
                        {cases.map((c, i) => (
                            <article
                                key={c.name}
                                data-testid={`case-card-${i}`}
                                className={`group relative ${
                                    i % 2 === 0 ? "lg:translate-y-10" : ""
                                }`}
                            >
                                <div className="relative aspect-[3/4] overflow-hidden bg-[#D8B9A7]/30">
                                    <img
                                        src={c.image}
                                        alt={c.name}
                                        className="w-full h-full object-cover transition-transform duration-[1100ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#1E1E1E]/55 via-transparent to-transparent opacity-90" />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                                        <div className="text-[10px] tracking-[0.28em] uppercase text-[#C6A76A] mb-1.5">
                                            0{i + 1} / Caso
                                        </div>
                                        <h4 className="font-display text-[#F7F3EE] text-lg md:text-xl leading-tight">
                                            {c.name}
                                        </h4>
                                        <p className="text-[11px] md:text-[12px] text-[#F7F3EE]/85 mt-1.5 leading-snug font-light">
                                            {c.role}
                                        </p>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
